"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgMailCircle(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12 0c6.628 0 12 5.373 12 12 0 6.628-5.372 12-12 12-6.627 0-12-5.372-12-12C0 5.374 5.374 0 12 0zm0 1.532C6.22 1.532 1.532 6.22 1.532 12c0 5.782 4.687 10.468 10.468 10.468 5.782 0 10.468-4.686 10.468-10.468 0-5.78-4.686-10.468-10.468-10.468zM6.358 8.32l5.17 4.354.096.066a.75.75 0 00.752 0l.095-.066 5.171-4.353c.052.137.087.283.1.435l.008.153v5.455c0 .866-.668 1.58-1.516 1.653l-.143.006H7.909c-.866 0-1.58-.668-1.653-1.516l-.006-.143V8.909c0-.207.038-.406.108-.589zm9.733-1.07c.149 0 .293.02.43.057L12 11.126l-4.521-3.82c.091-.024.186-.04.283-.05l.147-.006h8.182z",
    fill: "inherit",
    fillRule: "nonzero"
  }));
}

var _default = SvgMailCircle;
exports.default = _default;